<template>
    <div>
        <vs-popup :title="$t('make_appointment')" :active.sync="model">
            <div class="flex justify-between">
                <vs-button
                    icon="keyboard_arrow_left"
                    @click="setDate('prev')"
                    type="border"
                    >
                    <span class="hidden sm:inline-flex">
                        {{ $t("prev-week") }}
                    </span>

                </vs-button>
                <span class="text-xl">{{ beginDate }}</span>
                <vs-button
                    icon-after
                    icon="keyboard_arrow_right"
                    @click="setDate('next')"
                    type="border"
                    >
                    <span class="hidden sm:inline-flex">
                        {{ $t("next-week") }}
                    </span>
                </vs-button>
            </div>
            <h5 class="mt-4">{{ $t("select_date") }}</h5>
            <div class="mt-4" v-if="week.length > 0">
                <div :class="wMobile ? 'flex-col' : ''" class="flex">
                    <div class="ml-2" v-for="day in week" :key="day.uid" @click="changeDate(day.date)">
                        <vs-radio
                            v-model="selectDay"
                            :vs-value="day.code - 1"
                            >{{
                                day["name_" + $i18n.locale] + " " + day.date
                            }}</vs-radio
                        >
                    </div>
                </div>

                <div class="mt-8">
                    <h5>{{ $t("select_time") }}</h5>
                    <div class="flex flex-wrap mt-4">
                        <div
                            v-for="(item, i) in week[selectDay].dayofweek"
                            :key="i"
                        >
                            <div class="flex justify-between ml-2 mt-2">
                                <vs-button
                                    ref="loadableButton"
                                    id="button-with-loading"
                                    class="vs-con-loading__container"
                                    @click="make(item)"
                                    >{{ item.start_time }}</vs-button
                                >
                            </div>
                        </div>
                    </div>
                    <div v-if="week[selectDay].dayofweek.length === 0">
                        <span>{{ $t("time_is_not") }}</span>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    props: {
        value: [Boolean],
        specialist: [String],
    },
    components: {},
    data() {
        return {
            week: [],
            weekDays: [],
            configdateTimePicker: {
                enableTime: true,
                enableSeconds: true,
                noCalendar: true,
            },
            beginDate: this.$moment().format("DD.MM.YYYY"),
        };
    },

    async created() {
        this.getInfo();
    },

    watch: {
        beginDate() {
            this.getInfo();
        },
        specialist() {
            this.getInfo();
        },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
        wMobile() {
            return window.innerWidth < 800;
        },
        selectDay(){
            let date_week = 0
            this.week.filter((item,index)=>{
                if (item.date == this.beginDate){
                    date_week = index
                }
            })
            return date_week
        },
    },
    methods: {
        changeDate(selectDate) {
            this.beginDate = selectDate
        },
        async getInfo() {
            if (this.specialist !== undefined) {
                this.$vs.loading();
                const res = await this.$http(
                    `specialists/user-appointment/?begin_date=${ this.beginDate }&type=${ this.specialist }`
                );
                this.week = res.data;
                this.$vs.loading.close();
            }
        },
        setDate(da) {
            if (da === "prev") {
                this.beginDate = this.$moment(
                    this.beginDate.replace(/(\d+).(\d+).(\d+)/, "$3/$2/$1")
                )
                    .subtract(7, "days")
                    .format("DD.MM.YYYY");
            } else {
                this.beginDate = this.$moment(
                    this.beginDate.replace(/(\d+).(\d+).(\d+)/, "$3/$2/$1")
                )
                    .add(7, "days")
                    .format("DD.MM.YYYY");
            }
        },
        async make(item) {
            this.$vs.loading();
            try {
                const res = await this.$http.patch(
                    `specialists/user-appointment/sign/${ item.uid }/`
                );
                if (res !== undefined && res.status === 200) {
                    this.$vs.notify({
                        title: this.$t("succesful"),
                        color: "success",
                    });
                }
            } catch (e) {
                this.$vs.notify({
                    text: e["message_" + this.$i18n.locale],
                    color: "danger",
                });
            }
            this.$vs.loading.close();
        },
    },
};
</script>

<style>
.vs-popup {
    width: 1000px !important;
}
</style>
